module.exports = __webpack_public_path__ + "static/media/Dayly_ios_6_preview.6b5736d7.jpg";